import { BaseEntity } from '@models';
import { Type } from 'class-transformer';
import { CarModel } from '../car-model';
import { Organization } from '../organization';
import { CarListBand } from '../car-list-band';

export class CarListBandModel extends BaseEntity {
	organizationId: string;
	carListBandId: string;
	carModelId: number;

	@Type(() => Organization)
	organization: Organization;

	@Type(() => CarListBand)
	carListBand: CarListBand;

	@Type(() => CarModel)
	carModel: CarModel;
}
